import type { IconGlyph } from '../icon';

/**
 * Tractie `moon` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.2.1 — `dist/jsx/m/moon.jsx`.
 */
export const iconMoon: IconGlyph = {
  name: 'moon',
  path: 'm20.47 17.28-.89-.19c-5.91-1.27-9.89-7.73-8.39-13.64s0-.03 0-.03l.12-.58v-.1a.7.7 0 0 0-.82-.74l-.1.02-.55.18h-.01c-3.82 1.32-6.5 4.86-6.8 8.89l-.02.39c-.21 9.78 11.57 14.12 17.85 6.96l.06-.08a.71.71 0 0 0-.44-1.08ZM4 11.52c.13-3.66 2.45-6.92 5.82-8.24l.33-.12.07-.02-.02.1c-1.62 6.44 2.69 13.46 9.16 14.84l.39.08C14 24.11 3.81 20.16 4 11.52',
};
